import React from 'react'
import { Modal } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { selectCurrentChannel, selectAllPublicKeys } from '../integrationsSlice'
import { useConnectionModalContent } from './hooks'

export default function ConnectionModal({ ownerId, sharedAccountIds, visible, closeModal, retrieveAccounts, accounts }) {
  /**
   *
   * Handle accounts
   *
   */
  const currentChannel = useSelector(selectCurrentChannel)
  const allPublicKeys = useSelector(selectAllPublicKeys)
  const { content } = useConnectionModalContent({ ownerId, sharedAccountIds, channel: currentChannel, retrieveAccounts, accounts, allPublicKeys })

  return (
    <Modal show={visible} onHide={closeModal} size="lg">
      <Modal.Body>{content}</Modal.Body>
    </Modal>
  )
}
